<ng-template #confirmFilterModal>
    <h5>You have filters applied already.</h5>
    <label>
        Would you like to filter by keyword
        <div class="badge badge-pill badge-dark mb-1">
            {{ keyword.keyword }}
        </div>
        instead?
    </label>
    <p>You will be returned to the {{ gallerySvc.writeGalleryPageText() }} gallery.</p>
</ng-template>
<div class="keyword-wrapper">    
    <div class="badge badge-pill badge-dark keyword ms-1 me-1 mb-1" [ngClass]="{'filter-match': filterMatchMode, 'related-match': matchesSynonymSearch || matchesHierarchySearch}"
        [style.font-size]="fontSize + 'rem'" (click)="changeFilterToMe($event)"
        [matTooltip]="filterMatchMode ? '' : 'Click to filter by \'' + keyword?.keyword + '\''">
        {{ keyword?.keyword || 'No keyword' }}
    </div>
    <div *ngIf="editMode && !restrictEdit" class="delBtn badge badge-pill badge-danger" title="Remove the link to this keyword"
        (click)="deleteMe()">
        &times;
    </div>
</div>